module.exports = __webpack_public_path__ + "static/media/burgenland_austria.62b2ab76.jpg";